var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 24.6691C2.44933 24.6691 1.60133 24.3184 0.976 23.6931C0.350667 23.0678 0 22.2198 0 21.3358V5.33578C0 4.45178 0.350667 3.60377 0.976 2.97844C1.60133 2.35444 2.44933 2.00244 3.33333 2.00244C7.85333 2.00244 24.1467 2.00244 28.6667 2.00244C29.5507 2.00244 30.3987 2.35444 31.024 2.97844C31.6493 3.60377 32 4.45178 32 5.33578V21.3358C32 22.2198 31.6493 23.0678 31.024 23.6931C30.3987 24.3184 29.5507 24.6691 28.6667 24.6691H13.3187C13.052 24.6691 12.8107 24.8278 12.7067 25.0731L10.7027 29.7478C10.2587 30.7851 9.20933 31.4304 8.08267 31.3584C6.95733 31.2864 5.99733 30.5144 5.688 29.4291L4.46533 25.1531C4.384 24.8664 4.12267 24.6691 3.82533 24.6691H3.33333Z",
    fill: "url(#paint0_linear_1455_6843)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_6843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5738 6.52993C14.1751 6.52993 13.8516 6.20637 13.8516 5.8077V4.79009C13.8516 4.39143 14.1751 4.06787 14.5738 4.06787C14.9725 4.06787 15.296 4.39143 15.296 4.79009V5.8077C15.296 6.20637 14.9725 6.52993 14.5738 6.52993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4644 6.52993C17.0657 6.52993 16.7422 6.20637 16.7422 5.8077V4.79009C16.7422 4.39143 17.0657 4.06787 17.4644 4.06787C17.8631 4.06787 18.1866 4.39143 18.1866 4.79009V5.8077C18.1866 6.20637 17.8631 6.52993 17.4644 6.52993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8709 9.16622H13.1365C12.9357 9.16622 12.7515 9.055 12.6576 8.87806C12.4843 8.55017 12.3926 8.17533 12.3926 7.794C12.3926 7.16494 12.636 6.57489 13.0787 6.13289C13.5214 5.69089 14.1107 5.44678 14.7398 5.44678H17.2676C18.5618 5.44678 19.6148 6.49978 19.6148 7.794C19.6148 8.17533 19.5231 8.55017 19.3497 8.87733C19.2559 9.055 19.0717 9.16622 18.8709 9.16622Z",
    fill: "#E6F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9453 15.1964H21.4175C21.0189 15.1964 20.6953 14.8728 20.6953 14.4742C20.6953 14.0755 21.0189 13.752 21.4175 13.752H23.9453C24.344 13.752 24.6675 14.0755 24.6675 14.4742C24.6675 14.8728 24.344 15.1964 23.9453 15.1964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5859 15.1964H8.05816C7.65949 15.1964 7.33594 14.8728 7.33594 14.4742C7.33594 14.0755 7.65949 13.752 8.05816 13.752H10.5859C10.9846 13.752 11.3082 14.0755 11.3082 14.4742C11.3082 14.8728 10.9846 15.1964 10.5859 15.1964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78352 20.6136C8.55891 20.6136 8.33791 20.5096 8.19707 20.3139C7.9638 19.9904 8.03674 19.539 8.3603 19.3057L10.5125 17.7529C10.8361 17.5204 11.2882 17.5926 11.5207 17.9161C11.754 18.2397 11.6811 18.6911 11.3575 18.9244L9.2053 20.4771C9.07746 20.5689 8.93013 20.6136 8.78352 20.6136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0687 11.3329C20.8441 11.3329 20.6231 11.2289 20.4822 11.0332C20.249 10.7096 20.3219 10.2582 20.6455 10.0249L22.7977 8.47215C23.122 8.2396 23.5733 8.31182 23.8059 8.63537C24.0392 8.95893 23.9662 9.41032 23.6427 9.6436L21.4905 11.1964C21.3626 11.2881 21.2153 11.3329 21.0687 11.3329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2195 20.6136C23.0728 20.6136 22.9255 20.5689 22.7977 20.4771L20.6455 18.9244C20.3219 18.6911 20.249 18.2397 20.4822 17.9161C20.7162 17.5926 21.1676 17.5204 21.4905 17.7529L23.6427 19.3057C23.9662 19.539 24.0392 19.9904 23.8059 20.3139C23.6651 20.5096 23.4441 20.6136 23.2195 20.6136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9343 11.3329C10.7877 11.3329 10.6404 11.2881 10.5125 11.1964L8.3603 9.6436C8.03674 9.41032 7.9638 8.95893 8.19707 8.63537C8.43035 8.31182 8.88246 8.2396 9.2053 8.47215L11.3575 10.0249C11.6811 10.2582 11.754 10.7096 11.5207 11.0332C11.3799 11.2289 11.1589 11.3329 10.9343 11.3329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9071 21.336H15.1016C12.4135 21.336 10.2266 19.1491 10.2266 16.461V12.4888C10.2266 9.80066 12.4135 7.61377 15.1016 7.61377H16.9071C19.5952 7.61377 21.7821 9.80066 21.7821 12.4888V16.461C21.7821 19.1491 19.5952 21.336 16.9071 21.336Z",
    fill: "url(#paint1_linear_1455_6843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 17.7241C15.6009 17.7241 15.2773 17.4006 15.2773 17.0019V11.9463C15.2773 11.5477 15.6009 11.2241 15.9996 11.2241C16.3982 11.2241 16.7218 11.5477 16.7218 11.9463V17.0019C16.7218 17.4006 16.3982 17.7241 15.9996 17.7241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5738 4.06787C14.1751 4.06787 13.8516 4.39143 13.8516 4.79009V5.61776C14.1289 5.50509 14.4286 5.44659 14.7377 5.44659H15.296V4.79009C15.296 4.39143 14.9725 4.06787 14.5738 4.06787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0037 5.44678H15.2981H14.7398C14.4307 5.44678 14.131 5.50528 13.8536 5.61794C13.5662 5.73422 13.3033 5.90756 13.0787 6.13289C12.636 6.57489 12.3926 7.16494 12.3926 7.794C12.3926 7.9955 12.4179 8.19556 12.4677 8.38694C13.2275 7.89728 14.1317 7.61344 15.1009 7.61344H16.0037V5.44678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2248 13.7524H8.05816C7.65949 13.7524 7.33594 14.076 7.33594 14.4747C7.33594 14.8733 7.65949 15.1969 8.05816 15.1969H10.2248V13.7524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4181 17.8198L8.35834 19.3054C8.03479 19.5387 7.96184 19.9901 8.19512 20.3137C8.33595 20.5094 8.55695 20.6134 8.78156 20.6134C8.92818 20.6134 9.07551 20.5686 9.20334 20.4769L11.0378 19.153C10.7677 18.7472 10.5568 18.2987 10.4181 17.8198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78156 8.33545C8.55768 8.33545 8.33668 8.43945 8.19512 8.63517C7.96184 8.95873 8.03479 9.41012 8.35834 9.64339L10.4181 11.129C10.5575 10.6502 10.7684 10.2017 11.0385 9.79506L9.20406 8.47123C9.07551 8.38023 8.92818 8.33545 8.78156 8.33545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 11.2241C15.6009 11.2241 15.2773 11.5477 15.2773 11.9463V17.0019C15.2773 17.4006 15.6009 17.7241 15.9996 17.7241V11.2241Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_6843",
    x1: 0.888889,
    y1: 3.36355,
    x2: 32.8889,
    y2: 24.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244AD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_6843",
    x1: 11.3359,
    y1: 8.66911,
    x2: 20.6693,
    y2: 20.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1160A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_6843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(7.33398 4.00244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon5);
export default __webpack_public_path__ + "static/media/message_card_icon5.da92ec2dae1dd03e9e6dc5b0f929ce8e.svg";
export { ForwardRef as ReactComponent };